module.exports = __webpack_public_path__ + "img/hunt_convert_btn.643643b3.png";